import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

import HaierService from "../../images/heatpumps/HaierService.jpg";
import SlideShow from "../../components/slider";
import GradientHero from "../../components/gradientHero";
import Layout from "../../components/layout";

const ServiceAndMaintenance = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "commercial/service-and-maintenance", idType: URI) {
          commercialServiceMaintenance {
            heroBackgroundColor
            heroContent
            heroHeader
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            smItems {
              content
              header
              image {
                altText
                sourceUrl
              }
            }
            smLink {
              target
              title
              url
            }
            contentOne: ssContent1
            contentTwo: ssContent2
            ssHeader
            summaryContent
            summaryHeader
            summaryImage {
              altText
              sourceUrl
            }
            summaryLink {
              target
              title
              url
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.commercialServiceMaintenance || {};

  return (
    <Layout pageContext={pageContext}>
      <GradientHero image={data?.heroImage?.sourceUrl}>
        <h5>{data?.heroHeader}</h5>

        <p dangerouslySetInnerHTML={{ __html: data?.heroContent }}></p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </GradientHero>

      <div className="bg-black">
        <div className="max-w-7xl text-center mx-5 md:mx-20 lg:mx-auto py-20">
          <img
            style={{ maxWidth: "100px" }}
            className="mx-auto"
            width="100%"
            src={data?.summaryImage?.sourceUrl}
            alt={data?.summaryImage?.altText}
          />
          <h3 className="text-4xl mt-10">{data?.summaryHeader}</h3>
          <p
            className="text-xl text-white mb-10"
            dangerouslySetInnerHTML={{ __html: data?.summaryContent }}
          ></p>
          <a
            className="mt-30 bg-tan text-2xl text-black uppercase font-anton px-5 py-2"
            href={data?.summaryLink?.url}
            dangerouslySetInnerHTML={{ __html: data?.summaryLink?.title }}
          ></a>
        </div>
      </div>

      <div className="text-center mb-28 content-section">
        <ul className=" gap-y-20 text-left pt-28 pb-24 flex flex-wrap grid grid-cols-1 lg:grid-cols-2 gap-x-20 max-w-7xl mx-10 sm:mx-auto">
          {data?.smItems?.map((v, i) => (
            <li key={i} className="grid grid-cols-1 sm:grid-cols-6 flex">
              <div className="col-span-1 mt-0.5">
                <img
                  className="sm:w-full sm:mb-0 mb-5"
                  src={v?.image?.sourceUrl}
                />
              </div>
              <div className="col-span-5">
                <h3 className="text-4xl text-black mb-2">{v?.header}</h3>
                <div
                  className="commercial-content text-xl leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: v?.content }}
                ></div>
              </div>
            </li>
          ))}
        </ul>
        <a
          className="bg-tan text-xl text-black uppercase font-anton px-12 py-2"
          href={data?.smLink?.url}
          target={data?.smLink?.target}
        >
          {data?.smLink?.title}
        </a>
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }}>
        <div className="max-w-5xl text-center lg:mx-auto mx-5 py-20">
          <h3 className="text-4xl text-black mb-10">{data?.ssHeader}</h3>
          <div
            className="text-xl text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: data?.contentOne }}
          ></div>
          <div className="bg-tan w-36 h-0.5 mx-auto my-20" />
          <div
            className="text-xl text-left leading-relaxed"
            dangerouslySetInnerHTML={{ __html: data?.contentTwo }}
          ></div>
        </div>
      </div>
    </Layout>
  );
};

export default ServiceAndMaintenance;
